export default __webpack_public_path__ + "static/media/deal.5ac722a0.png";